import fromAnyToCoinNum from 'utils/converters/any/fromAnyToCoinNum.util';
import fromAnyToCoinStr from 'utils/converters/any/fromAnyToCoinStr.util';
import fromAnyToDecimal from 'utils/converters/any/fromAnyToDecimal.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import isNegativeNumber from 'utils/predicates/number/isNegativeNumber.util';
import isPositiveNumber from 'utils/predicates/number/isPositiveNumber.util';

const L = logger('parseMoney');

const reCutOff = (min, max) => new RegExp(`([^.]*.\\d{${min},${max}})(.*)`);

const DECIMALS_MIN = 0;
const DECIMALS_MAX = 2;

const RE_CUT_OFF_DECIMALS = reCutOff(DECIMALS_MIN, DECIMALS_MAX);
const RE_CUT_OFF_LEADING = /^(-?)(0+)([1-9].*)/;

const calculateValue = ({ is, coin, displayDecimals, string }) => {
  if (is.int && displayDecimals === 'mixed') return fromAnyToTrimmed(coin.num);
  if (is.int || is.rounded) return coin.str;

  return string;
};

const parseMoney = withOptions(({ value: raw, displayDecimals, noNegative }) => {
  try {
    const cleared = fromAnyToDecimal(raw);

    const nan = Number.isNaN(cleared);
    const infinite = cleared === Infinity || cleared === -Infinity;

    const number = nan || infinite ? NaN : fromAnyToNumber(cleared);

    const empty = raw === '' || raw === null || raw === void 1;
    const float = Number.isFinite(number);
    const int = Number.isSafeInteger(number);
    const negative = isNegativeNumber(number);
    const positive = isPositiveNumber(number);

    const valid = float && (noNegative ? !negative : true);

    const coinStr = fromAnyToCoinStr(cleared);
    const coinNum = fromAnyToCoinNum(cleared);

    const rounded = float && !String(number).startsWith(String(coinNum));

    const string = nan || infinite ? '' : fromAnyToString(cleared).replace(RE_CUT_OFF_DECIMALS, '$1').replace(RE_CUT_OFF_LEADING, '$1$3');

    const is = { float, int, negative, rounded, positive, nan, infinite, empty, valid };
    const coin = { str: coinStr, num: coinNum };

    const value = calculateValue({ is, coin, displayDecimals, number, string });

    return { is, coin, raw, number, string, value };
  } catch (error) {
    L.warn('()', error);

    const is = { valid: false, error: true };
    const coin = { str: '', num: NaN };

    return { is, coin, raw, number: NaN, string: '', value: '', error };
  }
});

// noinspection JSUnusedGlobalSymbols
export default parseMoney;
